import React from 'react';
import { MapPin, Truck, Clock, Phone, Info, CheckCircle } from 'lucide-react';
import Card from '../components/Card';
import { useZones } from '../hooks/useZones';
import LoadingSpinner from '../components/LoadingSpinner';

const Coverage = () => {
  const { zones, loading } = useZones();

  // Separar zonas activas e inactivas
  const activeZones = zones.filter(z => z.active);

  return (
    <div className="min-h-screen bg-background pt-20 pb-24 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
            <MapPin size={32} className="text-primary" />
          </div>
          <h1 className="text-3xl font-display font-bold text-[#1B263B] mb-2">
            Zonas de Cobertura
          </h1>
          <p className="text-[#7A756F]">
            Consulta si realizamos entregas en tu zona
          </p>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-2 gap-4 mb-8">
          <Card padding="small" className="text-center">
            <Truck size={24} className="mx-auto mb-2 text-primary" />
            <p className="font-semibold text-[#1B263B] text-sm">Entrega a domicilio</p>
            <p className="text-xs text-[#7A756F]">En todas las zonas</p>
          </Card>
          <Card padding="small" className="text-center">
            <Clock size={24} className="mx-auto mb-2 text-primary" />
            <p className="font-semibold text-[#1B263B] text-sm">Horario flexible</p>
            <p className="text-xs text-[#7A756F]">Según disponibilidad</p>
          </Card>
        </div>

        {/* Zones List */}
        {loading ? (
          <div className="flex justify-center py-12">
            <LoadingSpinner size="lg" />
          </div>
        ) : activeZones.length > 0 ? (
          <Card className="mb-6">
            <h2 className="font-display font-bold text-lg text-[#1B263B] mb-4 flex items-center gap-2">
              <CheckCircle size={20} className="text-[#38B000]" />
              Zonas con cobertura
            </h2>
            <div className="space-y-3">
              {activeZones.map((zone) => (
                <div
                  key={zone.id}
                  className="flex items-center justify-between p-4 bg-[#F8F7F5] rounded-xl"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#E85D04]/10 flex items-center justify-center flex-shrink-0">
                      <MapPin size={20} className="text-[#E85D04]" />
                    </div>
                    <div>
                      <p className="font-semibold text-[#1B263B]">{zone.name}</p>
                      {zone.delivery_time && (
                        <p className="text-xs text-[#7A756F]">
                          {zone.delivery_time}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-display font-bold text-[#E85D04]">
                      ${zone.cost.toLocaleString()}
                    </p>
                    <p className="text-xs text-[#7A756F]">envío</p>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        ) : (
          <Card className="text-center py-12">
            <Info size={48} className="mx-auto mb-4 text-[#BCB8B1]" />
            <h3 className="font-display font-bold text-lg text-[#1B263B] mb-2">
              No hay zonas configuradas
            </h3>
            <p className="text-[#7A756F]">
              Por favor, contáctanos para verificar cobertura en tu zona.
            </p>
          </Card>
        )}

        {/* No Coverage Info */}
        <Card className="bg-[#1B263B] text-white">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
              <Info size={24} className="text-white" />
            </div>
            <div>
              <h3 className="font-display font-bold text-lg mb-2">
                ¿No encuentras tu zona?
              </h3>
              <p className="text-white/80 text-sm mb-4">
                Estamos expandiendo nuestra cobertura constantemente. 
                Contáctanos y te informaremos si podemos hacer entregas en tu ubicación.
              </p>
              <a 
                href="https://wa.me/+56900000000" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#38B000] font-semibold hover:underline"
              >
                <Phone size={16} />
                Consultar disponibilidad
              </a>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Coverage;
